import React from "react";

import { Container } from "react-bootstrap";

import { reservationAgreementEn } from "@/data/reservation-agreement-en.html";
import { reservationAgreementFr } from "@/data/reservation-agreement-fr.html";

import i18n from "../i18n";

const ReservationAgreement = () => {
  const { language } = i18n;

  return (
    <Container>
      {language === "fr" ? (
        <div dangerouslySetInnerHTML={{ __html: reservationAgreementFr }} />
      ) : (
        <div dangerouslySetInnerHTML={{ __html: reservationAgreementEn }} />
      )}
    </Container>
  );
};

export default ReservationAgreement;
